export const gtag = (...params) => window.gtag(...params);
